import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Balance = styled(Typography)`
  ${({ theme }) => theme.breakpoints.down('xs')} {
    font-size: 8vw;
  }
`;
